import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import '../style.css';

function SpanishClasses() {
  const testimonials = [
    { text: "Culturlingua provided us with a customized, flexible learning environment. We greatly improved our Spanish-speaking skills and fluency within two weeks. Highly recommend studying Spanish at Culturlingua in Tlaquepaque!", author: "Jeff Groce", detail: "USA" },
    { text: "I can't recommend Culturlingua enough! I had private instruction in the morning and cultural excursions in the afternoon — all in Spanish. The school made sure my experience was terrific.", author: "Jill Durfee", detail: "Language Learner" },
    { text: "Very good experience. The teachers are professional and the environment is perfect to practice and improve your Spanish.", author: "María Esther A.", detail: "Student" },
  ];

  return (
    <div className="page-wrapper">
      <Helmet>
        <title>Spanish Classes in Tlaquepaque | Culturlingua — Learn Spanish in Mexico</title>
        <meta name="description" content="Learn Spanish in Tlaquepaque, Guadalajara with certified teachers. Face-to-face and online Spanish classes for all levels. Cultural immersion included." />
      </Helmet>

      <div className="page-hero">
        <div className="section-tag">Spanish School</div>
        <h1>Spanish Lessons at Culturlingua</h1>
        <p>Your place to learn Spanish with certified teachers in beautiful Tlaquepaque, Jalisco.</p>
      </div>

      <section style={{background:'var(--navy)', padding:'0'}}>
        <Swiper
          modules={[Navigation, Pagination, Autoplay]}
          navigation pagination={{ clickable: true }}
          autoplay={{ delay: 5000, disableOnInteraction: false }}
          loop={true}
          className="modern-swiper"
          style={{maxHeight:'420px'}}
        >
          {[
            { src: './assets/school.avif', caption: 'Learn with Expert Teachers' },
            { src: './assets/tlaquepaque.avif', caption: 'Presential & Online Classes' },
            { src: './assets/number.webp', caption: 'CEFR-Based Methodology' },
          ].map(({ src, caption }) => (
            <SwiperSlide key={caption}>
              <div className="gallery-card" style={{borderRadius:0}}>
                <img src={src} alt={caption} style={{height:'420px', width:'100%', objectFit:'cover'}} />
                <div className="caption" style={{fontSize:'1.1rem', padding:'40px 32px 24px'}}>{caption}</div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </section>

      <section style={{background:'var(--cream)', padding:'80px 48px'}}>
        <div style={{maxWidth:'1100px', margin:'0 auto'}}>

          <div style={{textAlign:'center', marginBottom:'48px'}}>
            <div className="section-tag">Why choose us</div>
            <h2 className="section-headline">Why Culturlingua?</h2>
          </div>

          <div className="cards-grid" style={{marginBottom:'64px'}}>
            {[
              { icon: '🎯', title: 'Learn', desc: 'Learn Spanish in a colonial and friendly environment in the beautiful city of Tlaquepaque.' },
              { icon: '🗣️', title: 'Language Exchange', desc: 'Exchange languages with students who want to learn your language. A unique experience.' },
              { icon: '🎓', title: 'Qualified Teachers', desc: 'All our teachers are qualified and experienced to teach Spanish at any level.' },
              { icon: '🌎', title: 'Cultural Activities', desc: 'Enjoy the beautiful surroundings of Jalisco and learn about Mexican culture while studying.' },
            ].map(({ icon, title, desc }) => (
              <div className="modal-card" key={title}>
                <div className="modal-card-accent"></div>
                <div className="modal-card-body">
                  <div className="modal-icon">{icon}</div>
                  <h3>{title}</h3>
                  <p>{desc}</p>
                </div>
              </div>
            ))}
          </div>

          <div style={{display:'grid', gridTemplateColumns:'1fr 1fr', gap:'24px', marginBottom:'64px'}}>
            {[
              { title: 'Face-to-Face', img: './assets/presencial.png', desc: 'Immerse yourself in our classrooms in Tlaquepaque with personalized attention.' },
              { title: 'Online', img: './assets/digital-tools.jpeg', desc: 'Learn from anywhere with our interactive virtual platform and certified teachers.' },
            ].map(({ title, img, desc }) => (
              <div key={title} style={{borderRadius:'16px', overflow:'hidden', background:'white', boxShadow:'0 2px 12px rgba(0,0,0,0.06)'}}>
                <img src={img} alt={title} style={{width:'100%', height:'200px', objectFit:'cover', display:'block'}} />
                <div style={{padding:'24px'}}>
                  <h3 style={{fontFamily:'Fraunces, serif', fontWeight:'700', color:'var(--navy)', marginBottom:'8px'}}>{title}</h3>
                  <p style={{color:'var(--muted)', fontSize:'0.875rem'}}>{desc}</p>
                </div>
              </div>
            ))}
          </div>

          <div style={{textAlign:'center', marginBottom:'48px'}}>
            <div className="section-tag">Testimonios</div>
            <h2 className="section-headline">What our students say</h2>
          </div>

          <div className="testimonials-grid" style={{marginBottom:'60px'}}>
            {testimonials.map((t, i) => (
              <div className={`testi-card${i===1?' featured':''}`} key={i}>
                <div className="testi-stars">★★★★★</div>
                <p className="testi-text">"{t.text}"</p>
                <div className="testi-author">
                  <div className="testi-avatar">{t.author[0]}</div>
                  <div>
                    <div className="testi-name">{t.author}</div>
                    <div className="testi-detail">{t.detail}</div>
                  </div>
                </div>
              </div>
            ))}
          </div>

          <div style={{background:'var(--navy)', borderRadius:'20px', padding:'48px', textAlign:'center'}}>
            <h3 style={{fontFamily:'Fraunces, serif', fontSize:'1.8rem', color:'white', fontWeight:'900', marginBottom:'12px'}}>
              Ready to start?
            </h3>
            <div style={{display:'flex', gap:'16px', justifyContent:'center', flexWrap:'wrap', marginTop:'24px'}}>
              <Link to="/Placement-Test" className="btn-glow">Take Placement Test →</Link>
              <Link to="/Spanish-Fees" className="btn-outline">View Fees</Link>
              <Link to="/contacto" className="btn-outline">Contact Us</Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default SpanishClasses;
